var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-logo-container",class:{ 'collapse': _vm.collapse }},[_c('transition',{attrs:{"name":"sidebarLogoFade"}},[_c('div',{key:"collapse",staticClass:"sidebar-logo-link"},[_c('img',{staticClass:"sidebar-logo",attrs:{"src":_vm.logo,"id":"sidebar-logo","alt":"企业logo"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }